import { render } from "./Tab5.vue?vue&type=template&id=b0d56a6c&scoped=true"
import script from "./Tab5.vue?vue&type=script&lang=js"
export * from "./Tab5.vue?vue&type=script&lang=js"

import "./Tab5.vue?vue&type=style&index=0&id=b0d56a6c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d56a6c"]])

export default __exports__